<template>
  <div class="levels" :class="{ compact: size === 'compact' }">
    <div
      v-for="level in axis.levels"
      :key="level.id"
      class="level"
      :class="{ compact: size === 'compact' }"
    >
      <div v-if="size !== 'compact'" class="level-title small">
        <i class="fa fa-stream mr-1"></i>
        Level
      </div>
      <b-btn
        v-if="axis.levels.length > 1"
        size="sm"
        variant="link-dark"
        class="ml-1 level-remove"
        @click="removeLevel(level)"
      >
        <i class="fa fa-times"></i>
      </b-btn>
      <b-row>
        <!--<b-col>
          <b-form-group description="You can type “concept: foo” to search">
            <v-select
              v-model="level.layers"
              v-validate="{ required: true }"
              label="label"
              :size="size === 'compact' ? 'sm' : ''"
              data-vv-name="Layers"
              multiple
              :disabled="type === 'worldmap' || type === 'linechart'"
              :filter="customLayerOptionFilter"
              :filterable="layerOptionFilterEnabled"
              :options="layerOptions"
              @search="fetchLayerOptions"
            >
              <template v-slot:option="option">
                {{ option.label }}
                <i v-if="option.searchRequired" class="fa fa-book-open ml-1"></i>
                <i v-if="option.searchable" class="fa fa-search ml-1"></i>
              </template>
            </v-select>
          </b-form-group>
        </b-col>-->
        <b-col>
          <b-form-group description="You can type “concept: foo” to search">
            <multiselect
              v-model="level.layers"
              v-validate="{ required: true }"
              label="label"
              track-by="label"
              placeholder="Type to search"
              :size="size === 'compact' ? 'sm' : ''"
              :options="layerOptions"
              :multiple="true"
              :searchable="true"
              :internal-search="false"
              :clear-on-select="false"
              :close-on-select="false"
              :options-limit="300"
              :limit=selectLimit
              :limit-text="limitText"
              :disabled="type === 'worldmap' || type === 'linechart'"
              @search-change="customLayerOptionFilter"
              @select="customLayerOption"
              @close="clearLayerOptions"
            >
              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag multiselect__tag">
                  <span>{{ option.label }}</span>
                  <i class="multiselect__tag-icon" @click="remove(option)"></i>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <span>{{ props.option.label }}</span>
                <i v-if="props.option.searchRequired" class="fa fa-book-open ml-1"></i>
                <i v-if="props.option.searchable" class="fa fa-search ml-1"></i>
              </template>
              <span slot="noResult">
                Oops! No elements found. Consider changing the search query.
              </span>
            </multiselect>
          </b-form-group>
        </b-col>
        <!--<b-col v-if="size !== 'compact'" cols="4" class="text-center pl-0">
          <b-input-group prepend="Max">
            <b-form-input
              v-model.number="level.max"
              v-validate="{ required: true }"
              type="number"
              data-vv-name="value"
              :min="1"
            ></b-form-input>
          </b-input-group>
        </b-col>-->
      </b-row>
      <div v-if="level.modifiers.length" class="modifiers">
        <div class="title small">
          <i class="fa fa-wrench mr-1"></i>
          Modifiers
        </div>

        <b-row
          v-for="modifier in level.modifiers"
          :key="modifier.id"
          class="mt-2"
        >
          <b-col cols="6">
            <b-form-select
              v-model="modifier.operator"
              v-validate="{ required: true }"
              :options="modifierOptions"
              data-vv-name="modifiers"
            ></b-form-select>
          </b-col>
          <b-col cols="5" class="text-center pl-0">
            <b-form-input
              v-model.number="modifier.value"
              v-validate="{ required: true }"
              type="number"
              data-vv-name="value"
              :min="1"
            ></b-form-input>
          </b-col>
          <b-col cols="1" class="pl-0">
            <b-btn
              size="sm"
              variant="secondary"
              class="mt-1"
              @click="removeModifier(level, modifier)"
            >
              <i class="fa fa-times"></i>
            </b-btn>
          </b-col>
        </b-row>
      </div>

      <b-row v-if="size !== 'compact'" class="mt-2">
        <b-col>
          <b-btn
            v-if="type !== 'worldmap'"
            v-b-popover.hover.bottom="
              level.grouped ? 'Ungroup level' : 'Group level'
            "
            size="sm"
            variant="outline-secondary"
            :class="{ toggled: level.grouped }"
            @click="toggleGroup(level)"
          >
            <i v-if="level.grouped" class="fa fa-fw fa-object-group"></i>
            <i v-else class="fa fa-fw fa-object-ungroup"></i>
          </b-btn>
          <b-btn
            v-if="type !== 'worldmap'"
            v-b-popover.hover.bottom="
              level.includeAll ? 'Don’t include all' : 'Include all'
            "
            size="sm"
            variant="outline-secondary"
            class="ml-1"
            :class="{ toggled: level.includeAll }"
            @click="toggleInclude(level)"
          >
            <i
              v-if="level.includeAll"
              class="fa fa-fw fa-compress-arrows-alt"
            ></i>
            <i v-else class="fa fa-fw fa-compress"></i>
          </b-btn>
          <b-btn
            v-if="type !== 'worldmap' && level.id > 1"
            v-b-popover.hover.bottom="
              level.linked ? 'Unlink level' : 'Link level'
            "
            size="sm"
            variant="outline-secondary"
            class="ml-1"
            :class="{ toggled: level.linked }"
            @click="toggleLink(level)"
          >
            <i v-if="level.linked" class="fa fa-fw fa-link"></i>
            <i v-else class="fa fa-fw fa-unlink"></i>
          </b-btn>
        </b-col>
        <b-col class="text-right ">
          <b-btn size="sm" variant="outline-secondary" @click="addModifier(level)">
            <i class="fa fa-plus"></i>
            Add modifier
          </b-btn>
        </b-col>
      </b-row>
    </div>

    <div
      v-if="
        axis.dimension !== 'z' &&
          multiple !== false &&
          type !== 'worldmap' &&
          type !== 'linechart'
      "
      class="text-right pt-2 add-level"
    >
      <b-btn size="sm" variant="primary" @click="addLevel">
        <i class="fa fa-plus"></i>
        Add level
      </b-btn>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";

export default {
  name: "ExploreAnalysisCreateAxis",
  components: {
    vSelect,
    Multiselect
  },
  props: {
    axis: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: null
    },
    selectLimit: {
      type: Number,
      required: false,
      default: 3
    }
  },
  data() {
    return {
      layerOptionFilterEnabled: true,
      defaultOptions: [],
      layerOptions: [],
      modifierOptions: [
        { value: "lt", text: "Less than" },
        { value: "gt", text: "Greater than" },
        { value: "top", text: "Top" },
        { value: "bottom", text: "Bottom" }
      ]
    };
  },
  computed: {
    ...mapState({
      fields: state => state.field.fields,
      filters: state => state.filter.filters,
      indices: state => state.ttc.indices,
      metas: state => state.ttc.metas,
      ttc: state => state.ttc.ttc,
      wikis: state => state.filter.wikis
    }),
    loadedFilters() {
      return this.filters.filter(f => f.name !== 'tempmaincat')
    },
    concepts() {
      let c = [];
      _.each(this.ttc, topic => {
        _.each(topic.children, theme => {
          c.push(...theme.children);
        });
      });
      return c;
    },
    themes() {
      let t = [];
      _.each(this.ttc, topic => {
        t.push(...topic.children);
      });
      return t;
    },
    topics() {
      return this.ttc;
    }
  },
  mounted() {
    this.setDefaultOptions();

    // Load default options (will be visible when dropdown open and no characters entered yet)
    this.layerOptions = this.defaultOptions;
  },
  methods: {
    ...mapActions(["searchIndices"]),
    setDefaultOptions() {
      let options = this.indices.map(indice => {
        let value;
        if (indice.name === "Word-Concept") {
          value = this.metas["Concept"][0];
        } else {
          value = this.metas[indice.name][0];
        }

        return {
          label: indice.name,
          value: value,
          searchable: true
        };
      });
      options.push({
        label: "All Categories",
        value: ["filt", 0],
        searchable: true
      });
      options.push({
        label: "Filtergroup",
        value: "filtergroup",
        searchable: true
        //searchRequired: true
      });
      options.push({
        label: "FilterSubgroup",
        value: "filtersubgroup",
        searchable: true
        //searchRequired: true
      });
      //options.push({
      //  label: "Wiki",
      //  value: null,
      //  searchRequired: true
      //});

      Object.keys(this.metas).forEach(key => {
        // Filter out specific options
        if (
          !key ||
          [
            "CRAiN Measures",
            "FilterGroup",
            "Wikipedia Category",
            "Day",
            "Month"
          ].includes(key)
        ) {
          return;
        }

        // Filter out metas that match indices
        if (
          options.some(o => o.label === key) ||
          options.some(o => o.label === key)
        ) {
          return;
        }

        let label = key;
        let searchable = false;
        let searchRequired = false;
        let value = this.metas[key][0];
        if (label.toLowerCase() === "userfilter") {
          label = "Filter";
          searchRequired = true;
          //value = null;
        }
        if (
          ["concept", "field", "theme", "topic"].includes(key.toLowerCase())
        ) {
          searchable = true;
        }

        options.push({
          label: label,
          value: value,
          searchable: searchable,
          searchRequired: searchRequired
        });
      });

      this.defaultOptions = _.sortBy(options, "label");
    },
    addLevel() {
      const maxId = _.maxBy(this.axis.levels, "id");
      this.axis.levels.push({
        id: maxId ? maxId.id + 1 : 1,
        modifiers: [],
        grouped: false,
        includeAll: false,
        linked: false,
        layers: [],
        //max: 1000
      });
    },
    addModifier(level) {
      const maxId = _.maxBy(this.axis.levels[level.id - 1].modifiers, "id");
      this.axis.levels[level.id - 1].modifiers.push({
        id: maxId ? maxId.id + 1 : 1
      });
    },
    removeLevel(level) {
      this.$bvModal.msgBoxConfirm("Remove level?").then(value => {
        if (value) {
          let i = this.axis.levels.findIndex(l => l.id === level.id);
          this.axis.levels.splice(i, 1);
        }
      });
    },
    removeModifier(level, modifier) {
      //console.log(level, modifier);
      let i = level.modifiers.findIndex(l => l.id === modifier.id);
      level.modifiers.splice(i, 1);
    },
    toggleInclude(level) {
      level.includeAll = !level.includeAll;
    },
    toggleGroup(level) {
      level.grouped = !level.grouped;
    },
    toggleLink(level) {
      level.linked = !level.linked;
    },
    customLayerOptionFilter(search, options) {
      const parts = search.split(":");
      if (parts.length !== 2) {
        this.layerOptions = this.defaultOptions.filter(o =>
          o.label.toLowerCase().includes(search.toLowerCase())
        );
      }

      const area = parts[0].toLowerCase().trim();
      const query = parts[1].toLowerCase().trim();

      if (area === "concept") {
        const results = this.concepts.filter(c => c.name.includes(query));
        this.layerOptions = results.map(concept => {
          return {
            label: "Concept: " + concept.name,
            value: concept.id
          };
        });
      }

      if (area === "theme") {
        const results = this.themes.filter(t => t.name.includes(query));
        this.layerOptions = results.map(theme => {
          return {
            label: "Theme: " + theme.name,
            value: theme.id
          };
        });
      }

      if (area === "topic") {
        const results = this.topics.filter(t => t.name.includes(query));
        this.layerOptions = results.map(topic => {
          return {
            label: "Topic: " + topic.name,
            value: topic.id
          };
        });
      }

      if (area === "field") {
        const results = this.fields.filter(f => f.name.includes(query));
        this.layerOptions = results.map(field => {
          return {
            label: "Field: " + field.name,
            value: field._id
          };
        });
      }

      if (area === "wiki") {
        let options = [];

        this.wikis.forEach(w => {
          if (w.name.toLowerCase().includes(query)) {
            if (options.findIndex(o => o.value === w._id) < 0) {
              // Prevent duplicates
              options.push({
                label: "Wiki: " + w.name,
                value: w._id
              });
            }
          }

          w.children.forEach(wc => {
            if (wc.name.toLowerCase().includes(query)) {
              if (options.findIndex(o => o.value === wc._id) < 0) {
                // Prevent duplicates
                options.push({
                  label: "Wiki: " + wc.name,
                  value: wc._id
                });
              }
            }
          });
        });

        this.layerOptions = _.sortBy(options, "label");
      }

      if (area === "filtergroup") {
        let options = [];

        this.loadedFilters.forEach(f => {
          if (f.name.toLowerCase().includes(query) && !f.name.toLowerCase().includes("_del")) {
            options.push({
              label: "Filtergroup: " + f.name,
              value: f._id
            });
          }

          /*f.children.forEach(fc => {
            if (fc.name.toLowerCase().includes(query)) {
              options.push({
                label: "Filtergroup: " + fc.name,
                value: fc._id
              });
            }
          });*/
        });

        this.layerOptions = _.sortBy(options, "label");
      }

      if (area === "filtersubgroup") {
        let options = [];

        this.loadedFilters.forEach(f => {
          f.children.forEach(fc => {
            if (fc.name.toLowerCase().includes(query) && !fc.name.toLowerCase().includes("_del")) {
              options.push({
                label: "FilterSubgroup: " + fc.name,
                value: fc._id
              });
            }
          });
        });

        this.layerOptions = _.sortBy(options, "label");
      }

      if (area === "filter") {
        let options = [];

        this.loadedFilters.forEach(f => {
          f.children.forEach(fc => {
            fc.children.forEach(fcc => {
              if (fcc.name.toLowerCase().includes(query) && !fcc.name.toLowerCase().includes("_del") && !fcc._id.toLowerCase().includes("invalid_filter_")) {
                options.push({
                  label: "Filter: " + fcc.name,
                  value: fcc._id
                });
              }
            });
          });
        });

        this.layerOptions = _.sortBy(options, "label");
      }

      const indice = this.indices.find(i => i.name.toLowerCase() === area);
      if (indice) {
        //loading(true);

        this.searchIndices({
          query: query,
          index: indice.name
        }).then(results => {
          //this.layerOptionFilterEnabled = false;

          this.layerOptions = results.map(o => {
            return {
              label: indice.name + ": " + o.name,
              value: o._id
            };
          });

          //loading(false);
        });
      }

      return [];
    },
    customLayerOption(e, id) {
      const parts = e.label.split(":");
      console.log(parts, this.axis);
      if (parts.length !== 2) {
        const exists = this.axis.levels[0].layers.find(
          l => l.label.split(":")[0].trim()[0] === e.label
        );
        if(exists) {
          let i = this.axis.levels[0].layers.findIndex(l => l.label.split(":")[0].trim()[0] === e.label);
          this.axis.levels[0].layers.splice(i, 1);
          this.customLayerOptionFilter(e.label+": ");
        }
        else {
          this.customLayerOptionFilter(e.label+": ");
        }
      }
      else{
        const exists = this.axis.levels[0].layers.find(
          l => l.label === parts[0].trim()
        );
        if(exists) {
          let i = this.axis.levels[0].layers.findIndex(l => l.label === parts[0].trim());
          this.axis.levels[0].layers.splice(i, 1);
        }
      }
    },
    clearLayerOptions() {
      this.layerOptions = this.defaultOptions;
      this.layerOptionFilterEnabled = true;
    },  
    fetchLayerOptions(search, loading) {
      const parts = search.split(":");
      if (parts.length !== 2) {
        this.layerOptions = this.defaultOptions;
        return;
      }

      const area = parts[0].toLowerCase().trim();
      const query = parts[1].toLowerCase().trim();

      const indice = this.indices.find(i => i.name.toLowerCase() === area);
      if (indice) {
        loading(true);

        this.searchIndices({
          query: query,
          index: indice.name
        }).then(results => {
          this.layerOptionFilterEnabled = false;

          this.layerOptions = results.map(o => {
            return {
              label: indice.name + ": " + o.name,
              value: o._id
            };
          });

          loading(false);
        });
      } else {
        this.layerOptionFilterEnabled = true;
      }
    },
    layersUpdated(values) {
      const faulty = values.find(v => v.value === null);
      if (faulty) {
        this.$toasted.show(faulty.label + " requires searching", {
          type: "error"
        });
      }

      this.axis.levels.forEach(level => {
        level.layers = level.layers.filter(layer => layer.value !== null);
      });
    }
  }
};
</script>
